import { RECEIVE_FOLD_BYTES } from '../../../shared/constants.js';
import type { FileMeta } from '../../../shared/transfer.js';
import { appendChunk, emptyAssembly, finishAssembly } from '../assembly.js';
import type { FileSink } from './file-sink.js';

/** Keeps the file in Blob storage until the user saves it. Used only where nothing can stream to disk. */
export const createMemorySink = (meta: FileMeta): FileSink => {
  let assembly = emptyAssembly();
  return {
    kind: 'memory',
    write: (chunk) => {
      assembly = appendChunk(assembly, chunk, RECEIVE_FOLD_BYTES);
      return Promise.resolve();
    },
    close: () => Promise.resolve({ kind: 'in-memory', blob: finishAssembly(assembly, meta.mimeType) }),
    abort: () => {
      assembly = emptyAssembly();
      return Promise.resolve();
    },
  };
};
